import React from 'react';
import Card from 'react-bootstrap/Card';

/*
  BasicCard
  ----------
  Small wrapper around React-Bootstrap's <Card> component.

  Why this exists:
  - Bootstrap cards are used in a  few places.
  - This component gives us one consistent API for:
      * header content
      * optional title
      * body content (children)
      * optional footer
      * custom classNames for each section
  - That way, if we ever change how cards look or behave,
    we only have to update this file.
*/
export default function BasicCard({
    header,            // React node for the card header (can be JSX, text, etc.)
    title,             // Optional title rendered inside the card body
    footer,            // React node for the card footer
    children,          // Main card content passed between <BasicCard> ... </BasicCard>

    className = '',        // Extra classes for the outer <Card>
    bodyClassName = '',    // Extra classes for <Card.Body>
    headerClassName = '',  // Extra classes for <Card.Header>
    footerClassName = '',  // Extra classes for <Card.Footer>
    titleClassName = ''    // Extra classes for <Card.Title>
}) {
    return (
        // Outer Bootstrap card container
        <Card className={className}>
            {/* 
              Header section:
              Only render this if a `header` prop was passed in.
              This keeps the markup clean when there is no header.
            */}
            {header && (
                <Card.Header className={headerClassName}>
                    {header}
                </Card.Header>
            )}

            {/* 
              Body section:
              Always rendered, because `children` is where most content lives.
              Optional `title` is rendered at the top of the body if provided.
            */}
            <Card.Body className={bodyClassName}>
                {title && (
                    <Card.Title className={titleClassName}>
                        {title}
                    </Card.Title>
                )}

                {/* Main content of the card (whatever the caller passes in) */}
                {children}
            </Card.Body>

            {/* 
              Footer section:
              Only render this if a `footer` prop was passed in.
              Good place for meta info, links, or actions.
            */}
            {footer && (
                <Card.Footer className={footerClassName}>
                    {footer}
                </Card.Footer>
            )}
        </Card>
    );
}